module.exports = __webpack_public_path__ + "img/sld_mfm_invs_7_dark.37dd10a6.svg";